'use strict';

import { GLOBAL } from './Global';
import { SALES_AND_MARKETING_V2 as SALES_AND_MARKETING_V2_PERMISSION_GROUPS } from '../PermissionsGroups';

const sales_and_marketing_v2_permissions_list = [];

for (const [key, value] of Object.entries(SALES_AND_MARKETING_V2_PERMISSION_GROUPS)) {
  sales_and_marketing_v2_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SALES_AND_MARKETING_V2 = {
  can: [
    ...GLOBAL.can,
    ...sales_and_marketing_v2_permissions_list,
  ],
};

export {
  SALES_AND_MARKETING_V2,
};
